import { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';

interface AdminHeaderTitleProps {
    title: string;
    style?: CSSProperties;
    truncateText?: boolean;
    widthPerCharacter?: number;
}

const titleStyle: CSSProperties = {
    fontSize: 30,
    fontWeight: Size.FontWeight.Regular,
    color: Color.DARK_GRAY,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
};

export const AdminHeaderTitleView = ({ title, style, truncateText }: AdminHeaderTitleProps) => (
    <div style={{ ...titleStyle, ...style }} title={title}>
        {title}
    </div>
);
